import FuelEconomicData from "./FuelEconomicData"

class EconomicData {
    public id: string = ""
    public isBase: boolean = true

    public fuelEconomicDatasInitial: Array<FuelEconomicData> = new Array()
    public fuelEconomicDatasModified: Array<FuelEconomicData> = new Array()
    public miscellaneousCostsInitial: number = 0
    public miscellaneousCostsModified: number = 0
    public technicalStopDuration: number = 0
    public dailyCosts: number = 0

    public initialInvestment: number = 0
    
    public financing: boolean = false
    public amountToFinance: number = 0
    public interestRate: number = 0
    public amortizationPeriod: number = 0
    public discountRate: number = 0

    public annualRentability = new Array<number>()
    public interestPerYear = new Array<number>()
    public vanPerYear = new Array<number>()
    public ecoEfficiency = new Array<number>()
}

export default EconomicData